export const FIND_A_PRO_RESULTS = "find a pro results"
export const FIND_A_PRO_STICKY_NAV = "sticky nav links"
